module.exports = __webpack_public_path__ + "img/bmcl_gallery11.15ca72d2.jpg";